import React from 'react';

import copy from './i18n/sv.json';

export default function SingleImageInput({
  title,
  description,
  image,
  onTypeChange,
  onUrlChange,
  onFileChange
}) {
  const currentImage = image || { type: 'url', value: '' };
  const strings = copy.createSiteAdmin.imageInput;

  return (
    <div className="array-card">
      <div className="array-card-header">
        <div>
          <p className="array-card-title">{title}</p>
          <p className="array-card-text">{description}</p>
        </div>
      </div>

      <div className="single-image-input">
        <select
          className="form-input image-row__type"
          value={currentImage.type}
          onChange={(event) => onTypeChange(event.target.value)}
        >
          <option value="url">URL</option>
          <option value="base64">{strings.uploadOption}</option>
        </select>

        {currentImage.type === 'url' ? (
          <input
            className="form-input"
            value={currentImage.value}
            placeholder={strings.logoPlaceholder}
            onChange={(event) => onUrlChange(event.target.value)}
          />
        ) : (
          <div className="image-upload">
            <input
              type="file"
              accept="image/*"
              className="form-input"
              onChange={(event) => onFileChange(event.target.files?.[0] || null)}
            />
            <span className="image-upload__status">
              {currentImage.value ? strings.imageSelected : strings.noImageSelected}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
